import { ProviderConfig } from "../types";
import * as openaiCompatible from "./openaiCompatible";
import * as gemini from "./gemini";
import * as anthropic from "./anthropic";
import { AdapterMessage, AdapterReply, ModelInfo, OnChunk } from "./types";

export { isProviderApiError } from "./types";
// AdapterMessage/AdapterReply/TokenUsage/OnChunk are used internally by the three adapter
// modules (each imports them directly from ./types) but have no consumer outside this folder —
// only ModelInfo is actually re-exported through here (modelCombobox.ts).
export type { ModelInfo } from "./types";
// Shown in Add/Edit Provider's "Max reply length" field placeholder (providerForm.ts) — only
// Anthropic requires this cap, so this is the only adapter with a constant worth exposing here.
export { DEFAULT_ANTHROPIC_MAX_TOKENS } from "./anthropic";
// Read by storage.ts's getDefaultMaxContextTokens/isModelSpecificMaxContext (the live tier of
// the Max-context 3-tier resolution) — see that cache's own comment in adapters/types.ts.
export { getLiveContextTokens } from "./types";

export async function sendMessage(
  config: ProviderConfig,
  messages: AdapterMessage[],
  signal?: AbortSignal,
  onChunk?: OnChunk
): Promise<AdapterReply> {
  if (config.adapterType === "gemini") {
    return gemini.sendMessage(config, messages, signal, onChunk);
  }
  if (config.adapterType === "anthropic") {
    return anthropic.sendMessage(config, messages, signal, onChunk);
  }
  return openaiCompatible.sendMessage(config, messages, signal, onChunk);
}

export async function listModels(
  config: Pick<ProviderConfig, "endpoint" | "apiKey" | "adapterType">
): Promise<ModelInfo[]> {
  if (config.adapterType === "gemini") {
    return gemini.listModels(config);
  }
  if (config.adapterType === "anthropic") {
    return anthropic.listModels(config);
  }
  return openaiCompatible.listModels(config);
}
